import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useEffect, useRef, useState } from "react";
import { hapticTap } from "../helpers/haptics";
import { optionButtonSx } from "./OptionButton";

const FLASH_MS = 800;

type FlashAction = "randomize" | "reorder";

const OrderButtons = ({
  shuffled,
  onRandomize,
  onReorder
}: {
  shuffled: boolean;
  onRandomize: () => void;
  onReorder: () => void;
}) => {
  const [flash, setFlash] = useState<FlashAction | null>(null);
  const timerRef = useRef<number | undefined>(undefined);

  useEffect(
    () => () => {
      window.clearTimeout(timerRef.current);
    },
    []
  );

  const pulse = (action: FlashAction) => {
    setFlash(action);
    window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => setFlash(null), FLASH_MS);
  };

  const randomizeActive = flash === "randomize";
  const reorderActive = flash === "reorder";

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
          gap: 2
      }}>
      <Button
        aria-label={randomizeActive ? "Randomized" : "Randomize"}
        onClick={() => {
          hapticTap();
          onRandomize();
          pulse("randomize");
        }}
        sx={{
          ...optionButtonSx(randomizeActive),
          width: "100%",
          minHeight: 48
        }}>
        {randomizeActive ? "Randomized" : "Randomize"}
      </Button>
      <Button
        disabled={!shuffled && !reorderActive}
        aria-label={reorderActive ? "Reordered" : "Reorder"}
        onClick={() => {
          hapticTap();
          onReorder();
          pulse("reorder");
        }}
        sx={{
          ...optionButtonSx(reorderActive),
          width: "100%",
          minHeight: 48
        }}>
        {reorderActive ? "Reordered" : "Reorder"}
      </Button>
    </Box>
  );
};

export default OrderButtons;
